import axiosClient from '..';

export const homeApi = {
  getHome: async () => {
    return await axiosClient.get('/home');
  },
};
